import { NgModule } from '@angular/core'
import { BaseTmsModule, TmsConfig } from '@spartacus/tracking/tms/core'
import { LoginEvent, provideConfig } from '@spartacus/core'
import {
  CategoryPageResultsEvent, NavigationEvent, NavigationEventBuilder, ProductDetailsPageEvent, ProductPageEventBuilder,
  SearchPageResultsEvent
} from '@spartacus/storefront'
import { PageViewEvent } from '../cms/page/page-view-event'
import { GtmModule } from '@spartacus/tracking/tms/gtm'
import { environment } from '../../../environments/environment'
import { MbProductPageEventBuilder } from './events/mb-product-page-event.builder'
import { MbCartPageEventBuilder } from './events/mb-cart-page-event.builder'
import { MbCheckoutPageEventBuilder } from './events/mb-checkout-page-event.builder'
import { AnalyticsEvent } from './events/analytics.event'
import { MbProductClickDirective } from './directives/mb-product-click.directive'
import { MbMfqCollectorService } from './services/mb-mfq-collector.service'
import { MbGtmCollectorService } from './services/mb-gtm-collector.service'
import { MbMouseFlowEventBuilder } from './events/mb-mouse-flow-event.builder'
import { CheckoutPageEvent } from './events/checkout-page.event'
import { MouseFlowEvent } from './events/mouse-flow.event'
import { ProductClickEvent } from './events/product-click.event'
import { DownloadEvent } from '../cms/components/shared/gtm-event/download-event.events'
import { VideoPlayEvent } from '../cms/services/moving-image/video-events'
import { MbCartEventBuilder } from './events/mb-cart-event.builder'
import { MbNavigationEventBuilder } from './events/mb-navigation-event.builder'
import { MbWishlistEventBuilder } from './events/mb-wishlist-event.builder'
import { WishlistAddEntrySuccessEvent } from './events/wishlist.events'
import { PoUploadFailed, PoUploadSuccess } from './events/po-upload.events'
import { MbPoUploadClickEventBuilder } from './events/mb-po-upload-event.builder'
import { AuthenticationEvent } from './events/authentication.event'
import { SearchPageZeroResultsEvent } from './events/search-page-zero-results.event'
import { ProductFiltersEvent } from './events/product-filters.event'
import { CartEventBuilder, CartPageEventBuilder } from '@spartacus/cart/base/core'
import {
  CartAddEntrySuccessEvent, CartPageEvent, CartRemoveEntrySuccessEvent, CartUpdateEntrySuccessEvent
} from '@spartacus/cart/base/root'
import { OrderPlacedEvent } from '@spartacus/order/root'
import { FooterNavigationEvent } from '../cms/components/shared/events/footer-navigation-event'

const { google, production } = environment

const declarations = [
  MbProductClickDirective
]

@NgModule({
  imports: [
    BaseTmsModule.forRoot(),
    GtmModule,
  ],
  declarations,
  exports: declarations,
  providers: [
    {
      provide: ProductPageEventBuilder,
      useExisting: MbProductPageEventBuilder
    },
    {
      provide: CartPageEventBuilder,
      useExisting: MbCartPageEventBuilder
    },
    {
      provide: CartEventBuilder,
      useExisting: MbCartEventBuilder
    },
    {
      provide: NavigationEventBuilder,
      useExisting: MbNavigationEventBuilder
    },
    provideConfig({
      tagManager: {
        gtm: {
          gtmId: google.gtmId || 'GTM-TBJ5SR4',
          collector: MbGtmCollectorService,
          events: [
            NavigationEvent,
            CategoryPageResultsEvent,
            SearchPageResultsEvent,
            CartUpdateEntrySuccessEvent,

            // commerce events
            ProductDetailsPageEvent,
            CartPageEvent,
            CartAddEntrySuccessEvent,
            CartRemoveEntrySuccessEvent,
            CheckoutPageEvent,
            OrderPlacedEvent,
            ProductClickEvent,
            MouseFlowEvent,
            WishlistAddEntrySuccessEvent,
            PoUploadSuccess,
            PoUploadFailed,
            SearchPageZeroResultsEvent,
            ProductFiltersEvent,

            // cms events
            AnalyticsEvent,
            PageViewEvent,
            FooterNavigationEvent,

            //auth Events
            AuthenticationEvent
          ],
          debug: production,
        },
        mfq: {
          dataLayerProperty: '_mfq',
          collector: MbMfqCollectorService,
          events: [
            CartPageEvent,
            CartAddEntrySuccessEvent,
            OrderPlacedEvent,
            // customer reg (INT) // registration process finished → “registered” ???
            SearchPageResultsEvent,
            DownloadEvent,
            LoginEvent,
            VideoPlayEvent,
            //TopNavi (when Fkyout Navigation used) → “TopNavi” ???
            PageViewEvent
          ],
          debug: production
        }
      }
    } as TmsConfig)
  ]
})
export class AnalyticsModule {

  /* eslint-disable @typescript-eslint/naming-convention */
  constructor (_: MbCheckoutPageEventBuilder, __: MbMouseFlowEventBuilder, ___: MbWishlistEventBuilder, ____: MbPoUploadClickEventBuilder) {
  }

  /* eslint-enable @typescript-eslint/naming-convention */
}
